import React from 'react';
import { NavLink } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';

import { FaPencilAlt, FaOsi, FaTrash, FaList } from 'react-icons/fa';

import Const from '../../../util/Constants';
import DefaultControllerConst from '../../../util/DefaultControllerConst';
import Util from '../../../util/Util';
import Display from '../../../util/Display';

class FieldListRows extends React.Component {

  constructor(props) {
    super(props);
    this.models = reactLocalStorage.getObject(Const.Model);
  }

  options = (isGlobal, CatList, field) => {
    if(!isGlobal || !CatList || !field.field_type.includes(Const.Select)) return null;
    let tmp = field.field_type.split(Const.Opt);
    if(tmp.length === 2) {
      return <NavLink to={`/setting/${tmp[1]}`} 
        className="btn btn-sm btn-success mr-1 mb-1">
         <FaList /> Options
      </NavLink>;
    } else if(tmp.length === 3) {
      if(this.models[tmp[1]] && this.models[tmp[1]].fields[tmp[2]]) {
        return <NavLink to={`${this.props.path}/options/${this.models[tmp[1]].fields[tmp[2]].id}`} 
          className="btn btn-sm btn-success mr-1 mb-1">
           <FaList /> Options
        </NavLink>;
      } else return null;
    } else {
      return <NavLink to={`${this.props.path}/options/${field.id}`}
        className="btn btn-sm btn-success mr-1 mb-1">
         <FaList /> Options
      </NavLink>;
    }
  }

  render() {
    const isGlobal = this.props.context === DefaultControllerConst.Global;
    const fields = this.props.fields.map((field, _i) => (
      <tr key={`module_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{field.label_name}</td>
       
        {/* field details */}
        <td>
          <div className="small text-muted p-2 bg-light border rounded">
            <p className='m-0' style={{fontSize: "0.825rem"}}>
              <strong>Field Key:</strong> {field.field_key}
            </p>
            <p className='m-0' style={{fontSize: "0.825rem"}}>
              <strong>Field Type:</strong> {field.field_type}
            </p>
            <p className='m-0' style={{fontSize: "0.825rem"}}>
              <strong>Visible:</strong> {field.visible === Const.True ? Const.Yes : Const.No}
            </p>
            <p className='m-0' style={{fontSize: "0.825rem"}}>
              <strong>Editable:</strong> {field.editable === Const.True ? Const.Yes : Const.No}
            </p>
            {isGlobal && (
              <>
                <p className='m-0' style={{fontSize: "0.825rem"}}>
                  <strong>Validation:</strong> {field.validate || "N/A"}
                </p>
                <p className='m-0' style={{fontSize: "0.825rem"}}>
                  <strong>Unique:</strong> {field.non_duplicate === Const.True ? Const.Yes : Const.No}
                </p>
                <p className='m-0' style={{fontSize: "0.825rem"}}>
                  <strong>Form Mandatory:</strong> {field.form_mandate === Const.True ? Const.Yes : Const.No}
                </p>
                <p className='m-0' style={{fontSize: "0.825rem"}}>
                  <strong>API Mandatory:</strong> {field.api_mandate === Const.True ? Const.Yes : Const.No}
                </p>
                <p className='m-0' style={{fontSize: "0.825rem"}}>
                  <strong>Import Mandatory:</strong> {field.import_mandate === Const.True ? Const.Yes : Const.No}
                </p>
              </>
            )}

            <p className='m-0' style={{fontSize: "0.825rem"}}>
              <strong>Created By:</strong> {Display.ModelLabelValue('user', field.created_by)}
            </p>
            <p className='m-0' style={{fontSize: "0.825rem"}}>
              <strong>Created Date:</strong> {Util.serverStringToDisplayDateTime(field.created_date)}
            </p>
            <p className='m-0' style={{fontSize: "0.825rem"}}>
              <strong>Updated By:</strong> {Display.ModelLabelValue('user', field.updated_by)}
            </p>
            <p className='m-0' style={{fontSize: "0.825rem"}}>
              <strong>Updated Date:</strong> {Util.serverStringToDisplayDateTime(field.updated_date)}
            </p>
          </div>
        </td>

        {/* action buttons */}
        <td className="list-action-btn">
          {this.props.Update && (
            <button className="btn btn-sm btn-primary mr-1 mb-1" onClick={() => this.props.show(_i)}>
              <FaPencilAlt /> Edit
            </button>
          )}
          {isGlobal &&
            this.props.Delete &&
            field.status !== Const.AlwaysActive &&
            field.status !== Const.SpecialField && (
              <button className="btn btn-sm btn-danger mr-1 mb-1" onClick={() => this.props.delete(_i)}>
                <FaTrash /> Delete
              </button>
            )}
          {/* ... existing options call ... */}
          { this.options(isGlobal, this.props.CatList, field) }
          {this.props.showConditional ? (
            <NavLink
              to={`${this.props.path}/conditional/${field.id}`}
              className="btn btn-sm btn-info text-white mr-1 mb-1"
            >
              <FaOsi /> Conditional Fields
            </NavLink>
          ) : null}
        </td>
      </tr>
    ));
    return <tbody>{fields}</tbody>;
  }
}
export default FieldListRows;